module.exports = __webpack_public_path__ + "assets/img/favicon.fe3cef782e71568cd30341476bc93e12.png";